import { useQuery } from "@tanstack/react-query";
import { listBumblebeeSessions } from "../../../../../../../../../shared/api/bumblebee/bumblebee";

export const useBumblebeeSessions = (enabled = true) => {
	return useQuery({
		queryKey: ["bumblebee-sessions-data"],
		queryFn: () => listBumblebeeSessions(),
		enabled,
		staleTime: 1000 * 5,
		refetchInterval: 1000 * 30,
		refetchOnWindowFocus: true,
	});
};
